import { motion } from "framer-motion";
import { 
  AlertTriangle, 
  Clock, 
  Calculator, 
  Wallet, 
  TrendingDown,
  HelpCircle 
} from "lucide-react";

const painPoints = [
  {
    icon: Clock,
    text: "Trabalha o mês inteiro e não sabe quanto realmente ganhou",
  },
  {
    icon: Calculator,
    text: "Aceita projetos sem saber se vão dar lucro",
  },
  {
    icon: Wallet,
    text: "Cliente atrasa pagamento e bagunça seu fluxo de caixa",
  },
  {
    icon: HelpCircle,
    text: "Não sabe seu valor hora real",
  },
  {
    icon: TrendingDown,
    text: "Só descobre que o mês foi ruim quando ele já acabou",
  },
];

export function PainSection() {
  return (
    <section className="relative py-20 sm:py-28 bg-gradient-to-b from-background via-muted/30 to-background overflow-hidden">
      {/* Background effect */}
      <div className="absolute inset-0 opacity-50">
        <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-destructive/5 to-transparent" />
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 20% 50%, hsl(var(--destructive) / 0.05) 0%, transparent 50%),
                           radial-gradient(circle at 80% 50%, hsl(var(--destructive) / 0.03) 0%, transparent 50%)`
        }} />
      </div>

      <div className="container relative mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-destructive/10 border border-destructive/20 text-destructive text-sm font-medium mb-6">
            <AlertTriangle className="h-4 w-4" />
            Você se identifica?
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wide text-foreground">
            SE VOCÊ É FREELANCER,{" "}
            <span className="text-destructive">ISSO PROVAVELMENTE</span>
            <br />
            <span className="text-destructive">JÁ ACONTECEU COM VOCÊ:</span>
          </h2>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4">
          {painPoints.map((point, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative"
            >
              <div className="flex items-center gap-4 p-5 rounded-xl bg-card border border-border hover:border-destructive/30 hover:shadow-md transition-all duration-300">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-destructive/10 flex items-center justify-center group-hover:bg-destructive/20 transition-colors">
                  <point.icon className="h-6 w-6 text-destructive" />
                </div>
                <p className="text-lg text-muted-foreground group-hover:text-foreground transition-colors">
                  {point.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Transition statement */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-16"
        >
          <div className="inline-block">
            <div className="relative">
              {/* Glow effect */}
              <div className="absolute -inset-2 bg-gradient-to-r from-primary/10 to-primary/20 rounded-2xl blur-xl opacity-50" />
              <div className="relative bg-card border border-border rounded-2xl p-8 shadow-lg">
                <p className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
                  Isso não é falta de talento.
                </p>
                <p className="text-xl sm:text-2xl text-primary font-semibold">
                  É falta de sistema.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
